import React from 'react';

import {AccessoriesTabs} from './accessoriesTabs/accessoriesTabs';

import s from './newCartAccessoriesRedesign.scss';

/**
 * NewCartAccessoriesRedesign
 */
export const NewCartAccessoriesRedesign = () => {
    return (
        <>
            <h2 className={s.title}>Special offers for your cart</h2>
            <AccessoriesTabs />
        </>
    );
};
